import { render, staticRenderFns } from "./BaseLoaderDots.vue?vue&type=template&id=07ff6c0f&"
import script from "./BaseLoaderDots.vue?vue&type=script&lang=js&"
export * from "./BaseLoaderDots.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoaderDots.vue?vue&type=style&index=0&id=07ff6c0f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports